import { PropsWithChildren } from 'react';
import { observer } from 'mobx-react-lite';
import { useIntegratedScheduledEventQueueStore } from './use-integrated-scheduled-event-queue-store';
import { useDispatchAreaStore } from '../dispatch-areas/use-dispatch-areas';
import { QueueStateContext } from '../queues/context/queue-state-context';
import { WorkspacePanel } from '../panels/workspace-panel';
import { useRegisterQueueStore } from '../queues/queue-registry/use-register-queue-store';

export const ScheduledEventQueueStateProvider = observer(function ScheduledEventQueueStateProvider({
    workspacePanel,
    children,
}: PropsWithChildren<{
    workspacePanel: WorkspacePanel;
}>): React.ReactElement {
    const dispatchAreaStore = useDispatchAreaStore();
    const dispatchAreaIds = dispatchAreaStore.monitoredAndOwnedDispatchAreaIds;

    const store = useIntegratedScheduledEventQueueStore({
        workspacePanel,
        dispatchAreaIds,
    });

    useRegisterQueueStore(store);

    return <QueueStateContext.Provider value={store}>{children}</QueueStateContext.Provider>;
});
